import "./Dropdown.css";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";

export const InstallDropdown = ({
  options,
  isOpen,
  selectedAccount,
  handleSelection,
  handleSelectedList,
  handleDropDown,
  setAccountRequired,
  placeholder,
}) => {
  return (
    <div className="mb-4 font-light ">
      <div className="dropdown-button" onClick={handleDropDown}>
        <p className="text-[#808080]">
          {selectedAccount ? selectedAccount : placeholder}
        </p>

        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </div>
      {isOpen ? (
        <ul className="dropdown">
          {options.map((option, i) => {
            console.log(option.paymentType);
            return (
              <li
                className="option"
                key={i}
                onClick={() => {
                  handleSelectedList(option.details);
                  handleSelection(option.paymentType);
                  setAccountRequired("");
                }}
              >
                {option.paymentType}
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
};
